import axios from '@/plugins/axiosV2'
import utils from '@/helpers/utilidades'

const http = axios(process.env.VUE_APP_API_ANALYTICPOINT+'/acreditadores');

export default {
  obtener_acreditadores() {
    return http.get(`/`);
  },

  obtener_usuarios_account() {
    return http.get(`/usuarios`);
  },

  crear_acreditador(payload) {
    return http.post(`/`, payload);
  },

  editar_acreditador(id, payload) {
    return http.put(`/${id}`, payload);
  },

  eliminar_acreditador(id) {
    return http.delete(`/${id}`);
  }
}
